module.exports = __webpack_public_path__ + "static/media/G.ed5d0a75.png";